module.exports = __webpack_public_path__ + "assets/img/btn-detail-78199a8a.png";